export default {
  error_param: '參數錯誤',
  loading: '加載中...',
  version: '版本',
  size: '大小',
  query_failed: '查詢失敗',
  for_ios: '適用於iOS',
  for_android: '適用於Android',
  install: '安裝'
}
